import { render, staticRenderFns } from "./VerifyMyIdentity.vue?vue&type=template&id=ccc34078&"
import script from "./VerifyMyIdentity.vue?vue&type=script&lang=js&"
export * from "./VerifyMyIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccc34078')) {
      api.createRecord('ccc34078', component.options)
    } else {
      api.reload('ccc34078', component.options)
    }
    module.hot.accept("./VerifyMyIdentity.vue?vue&type=template&id=ccc34078&", function () {
      api.rerender('ccc34078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/payasguest/screens/PayAsGuest/VerifyMyIdentity.vue"
export default component.exports